var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83336 2H11.1667L6.99169 7.25L2.83336 2ZM0.541693 1.675C2.22503 3.83334 5.33336 7.83333 5.33336 7.83333V12.8333C5.33336 13.2917 5.70836 13.6667 6.16669 13.6667H7.83336C8.29169 13.6667 8.66669 13.2917 8.66669 12.8333V7.83333C8.66669 7.83333 11.7667 3.83334 13.45 1.675C13.875 1.125 13.4834 0.333336 12.7917 0.333336H1.20003C0.50836 0.333336 0.116693 1.125 0.541693 1.675Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter14);
export default __webpack_public_path__ + "97120/static/media/filter14.0e240bb0fd0a7214b0ab11354d668a71.svg";
export { ForwardRef as ReactComponent };